// extracted by mini-css-extract-plugin
export var button = "styles-module--button--8a97d";
export var container = "styles-module--container--3df52";
export var content = "styles-module--content--43bdb";
export var description = "styles-module--description--62bc5";
export var desktop = "1340px";
export var giant = "2200px";
export var imageContainer = "styles-module--imageContainer--e8704";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var price = "styles-module--price--879db";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";
export var title = "styles-module--title--2c001";
export var videoContainer = "styles-module--videoContainer--598f4";